import { Controller } from "@hotwired/stimulus"

// A step's dialog: the read-out by default, the edit form after the footer's "Edit" (the footer then offers Cancel and
// Save). Nothing is saved here: Save submits the form like any other.
export default class extends Controller {
    static targets = ["view", "form", "reading", "editing"]

    connect() {
        this.show(false)
    }

    edit() {
        this.show(true)
    }

    cancel() {
        this.show(false)
    }

    show(editing) {
        this.viewTargets.forEach((el) => { el.hidden = editing })
        this.formTargets.forEach((el) => { el.hidden = !editing })
        this.readingTargets.forEach((el) => { el.hidden = editing })
        this.editingTargets.forEach((el) => { el.hidden = !editing })
    }
}
